import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Components
import UserSettings from './UserSettings';

const Settings = observer(class Settings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageContent: null
    }
  }

  componentDidMount() {

    // Determine which settings page to show
    if(this.props.content === 'User') {
      this.setState({
        pageContent: <UserSettings {...this.props} />
      });
    }
  }

  render() {
    const { translation } = this.props;

    return(
      <main tabIndex="0" id="main-content" className="page">
        <div className="wrap">
          <header className="page__header">
            <h1 className="page__title">{translation.page_title}</h1>
          </header>

          {this.state.pageContent}
        </div>
      </main>
    )
  }
})

export default translate('Settings')(Settings);


// WEBPACK FOOTER //
// ./src/app/components/Settings/Settings.js